import { Links, Meta, Scripts, ScrollRestoration } from "react-router";
import { ReactNode } from "react";

export function Document({
  children,
  title,
}: {
  children: ReactNode;
  title?: string;
}) {
  return (
    <html lang="en" className="h-full">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {title ? <title>{title}</title> : null}
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/images/mediascribe-favicon-32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="256x256"
          href="/images/mediascribe-favicon-256.png"
        />
        <link
          rel="icon"
          type="image/svg+xml"
          href="/images/mediascribe-favicon.svg"
        />
        <Meta />
        <Links />
        <script
          src="https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"
          async
        />
      </head>
      <body className="h-full">
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}
